import $ from 'jquery'
import { createDownloadButton, initSlides } from '../abstracts/utils'

window.jQuery = $
require('jquery-zoom')

export default () => {
  $(() => {
    if (! $('body').hasClass('single-product')) return

    $('img.zoom-img')
      .wrap('<span class="zoom" style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        magnify: 1.5
      })

    $('.product-summary .images-caption ul li').click(e => {
      let $li = $(e.target).closest('li')
      let imgId = $li.data('img-target')

      if ($li.hasClass('active')) return    // already active

      $li.parent().children('li.active').removeClass('active')
      $li.addClass('active')
      $('.product-summary .images-main .zoom.active').removeClass('active')
      $(`.product-summary .images-main .zoom[data-img-id=${imgId}]`).addClass('active')
    })

    let $sectionTabs = $('.section-tabs')
    let $sectionTabContent = $('.section-tab-content')
    if ($sectionTabs.length && $sectionTabContent) {
      // click tab handler
      $sectionTabs.find('.nav-tabs li').click(e => {
        $(e.target).parent().parent().children().removeClass('active')
        $(e.target).parent().addClass('active')
        $sectionTabContent.find('.tab-pane').remove('active').fadeOut(200)
        $sectionTabContent.find('.tab-pane#' + $(e.target).data('target')).addClass('active').fadeIn(500)
      })
      // download price
      $sectionTabContent.find('#price .download a').click(e => {
        e.preventDefault()
        $.get(window.endpoint + '/get-price-tags-of-product-by-product-id', {
          product_id: $(e.target).attr('product-id')
        })
          .done(res => {
            // console.log('res', res)
            let urls = JSON.parse(res)
            for (let i = 0; i < urls.length; i++) {
              let element = createDownloadButton(urls[i])
              element.click()
              document.body.removeChild(element)
            }
          })
          .fail(err => {
            console.log('err', err)
          })
      })
    }
    let $sectionAccessoryProducts = $('.section-accessory-products')
    if ($sectionAccessoryProducts.length) {
      // slider
      initSlides($sectionAccessoryProducts.find('.slideshow:not(.slick-initialized.slick-slider)'), 5, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ])
    }
    let $sectionRelatedProducts = $('.section-related-products')
    if ($sectionRelatedProducts.length) {
      // slider
      initSlides($sectionRelatedProducts.find('.slideshow:not(.slick-initialized.slick-slider)'), 5, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ])
    }
  })
}
